import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import {
  CLocaleSwitcherScreen,
  CSeomatic,
  LocaleSwitcherEntity,
} from 'ui'
import { GetServerSidePropsContext } from 'next'
import { getSiteInfo, serverSideValidateWww } from 'shared'
import { gql } from '@urql/core'
import { setCacheHeaders } from '../helpers/cache-config'
import { defaultClient } from '../graphql/clients'
import fragments from '../helpers/gql-fragments'
import { localeSwitcherEntryFields } from '../graphql/locale-switcher-query'

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const isWww = serverSideValidateWww({ context })

  const isCraftLivePreview = context.query['x-craft-live-preview'] !== undefined

  if ((!isWww && !isCraftLivePreview) || !context.locale) {
    return {
      notFound: true,
    }
  }

  const siteInfo = getSiteInfo(context.locale ?? '')

  const { data, error, operation } = await defaultClient(siteInfo.handle).query(
    gql`
      query($uri: [String]!, $site: [String]) {
        entry(uri: $uri, site: $site) {
          ${fragments.seomatic}
          title
          ${localeSwitcherEntryFields}
        }
      }
    `,
    {
      uri: 'locale-switcher',
      site: siteInfo.handle,
    }
  )

  setCacheHeaders(context.res)

  return {
    props: {
      entry: data.entry,
      ...(await serverSideTranslations(context.locale ?? '', ['common'])),
    },
  }
}

type Props = {
  entry: LocaleSwitcherEntity
}

export default function LocaleSwitcher({ entry }: Props) {
  if (!entry) {
    return null
  }

  return (
    <div>
      <CSeomatic data={entry?.seomatic} />
      <CLocaleSwitcherScreen entry={entry} />
    </div>
  )
}